import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { SharedModule } from '../../sharedModule/shared.module';
import { StorybookModule } from '@app/storybook/storybook.module';
import { BackToAssignBtnComponent } from './components/back-to-assign-btn/back-to-assign-btn.component';
import { BatchActionBtnComponent } from './components/batch-action-btn/batch-action-btn.component';
import { BatchOrdersModalComponent } from './components/batch-orders-modal/batch-orders-modal.component';
import { ViewprintingjobsComponent } from './components/viewprintingjobs/viewprintingjobs.component';
import { GeneratingLabelItemComponent } from './components/generating-label-item/generating-label-item.component';
import { PrintJobItemComponent } from './components/print-job-item/print-job-item.component';
import { PrintStepTitleComponent } from './components/print-step-title/print-step-title.component';
import { RecentlyPrintedItemComponent } from './components/recently-printed-item/recently-printed-item.component';
import { ScanErrorComponent } from './components/scan-error/scan-error.component';
import { ScanInputModalComponent } from './components/scan-input-modal/scan-input-modal.component';
import { ScanModalsContainerComponent } from './components/scan-modals-container/scan-modals-container.component';
import { ScanOrderModalComponent } from './components/scan-order-modal/scan-order-modal.component';
import { ScanOrdersBtnComponent } from './components/scan-orders-btn/scan-orders-btn.component';
import { ScanOrderSuccessComponent } from './components/scan-order-success/scan-order-success.component';
import { ScanBatchSuccessComponent } from './components/scan-batch-success/scan-batch-success.component';
import { SelectScannedOrderComponent } from './components/select-scanned-order/select-scanned-order.component';
import { PrintErrorWarningComponent } from './components/print-error-warning/print-error-warning.component';
import { RecentlyPrintedDialog } from './components/recently-printed-dialog/recently-printed-dialog';
import { ScanInputForOrderModal } from './components/scan-input-for-order-modal/scan-input-for-order-modal';
import { MobileOrderDetails } from './components/mobile-order-details/mobile-order-details';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TplTagComponent } from './components/3pl-tag.component/3pl-tag.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [
    ViewprintingjobsComponent,
    ScanOrdersBtnComponent,
    PrintStepTitleComponent,
    GeneratingLabelItemComponent,
    RecentlyPrintedItemComponent,
    BackToAssignBtnComponent,
    PrintJobItemComponent,
    BatchActionBtnComponent,
    ScanInputModalComponent,
    ScanOrderModalComponent,
    ScanModalsContainerComponent,
    ScanErrorComponent,
    BatchOrdersModalComponent,
    ScanOrderSuccessComponent,
    ScanBatchSuccessComponent,
    SelectScannedOrderComponent,
    PrintErrorWarningComponent,
    RecentlyPrintedDialog,
    ScanInputForOrderModal,
    MobileOrderDetails,
    TplTagComponent,
  ],
  exports: [ScanModalsContainerComponent, BackToAssignBtnComponent],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    StorybookModule,
    SharedModule,
    CommonModule,
    MatRippleModule,
    CdkTableModule,
    MatDividerModule,
    MatProgressSpinnerModule,
  ],
  providers: [Location, { provide: LocationStrategy, useClass: PathLocationStrategy }],
})
export class PrintModule {}
